var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcExternalLink = function SvgIcExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 20 20"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#5166c7}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 4.8s-.1 0 0 0h-3.5c-.3 0-.6.3-.6.6s.3.6.6.6h1.9l-2.7 2.7c-.1.1-.2.3-.2.4 0 .3.3.6.6.6.2 0 .3-.1.4-.2l2.7-2.7v1.7c0 .3.3.6.6.6s.6-.3.6-.6V5.4c0-.3-.2-.5-.4-.6",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 10c-.3 0-.6.2-.6.6v3.1c0 .3-.2.5-.5.5H6.4c-.3 0-.5-.2-.5-.5V6.5c0-.3.2-.5.5-.5h2.8c.3 0 .5-.3.6-.6 0-.3-.2-.6-.6-.6H6.4c-.9 0-1.6.7-1.7 1.7v7.2c0 .9.7 1.6 1.7 1.7h7.2c.9 0 1.6-.7 1.7-1.7v-3.1c0-.3-.3-.6-.6-.6",
    className: "st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388 975h20v20h-20z",
    style: {
      fill: "none"
    },
    transform: "translate(-388 -975)"
  }));
};
export default SvgIcExternalLink;